import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { AccountService } from '../../data/services/account.service';
import { HttpParams } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.sass']
})
export class AccountDetailsComponent extends BaseComponent implements OnInit {

  account: any;
  memberArray: any;
  isLoading: boolean = true;
  destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<AccountDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService,
    private snackbar: SnackbarService,
    private snackbarService: MatSnackBar
  ) {
    super();
  }

  ngOnInit(): void {
    this.account = this.data.user;
    this.memberArray = this.account; 
    // this.getData(this.account);
  }

  getData(account: any) {
    const params = new HttpParams().set("id", this.data.user);

    this.accountService.getMemberByNumber(account).subscribe(
      (res) => {
        console.log(res)
        if (res.statusCode === 302) {
          this.memberArray = this.account; // Assigning entity to memberArray
          this.isLoading = false;
        } else {
          this.snackbar.showNotification("snackbar-error", "Member not found.");
        }
      },
      (error) => {
        this.isLoading = false;
        
        this.snackbarService.open("Member not found.", "Close", {
          panelClass: 'snackbar-danger',
          horizontalPosition: 'center',
          verticalPosition: 'top',
          duration: 3000
        })
      }
    );
  }

  logoutUser() {
    this.accountService
      .logoutUser({ number: this.account })
      .subscribe((res) => {
        this.snackbar.showNotification("snackbar-success", res.message);
        this.dialogRef.close();
      }, err => {
        this.snackbar.showNotification("snackbar-error", "Error logging out.");
      });
  }
}
